<script lang="ts">
  import type { Map as MlMap } from 'maplibre-gl';

  import { formatZoom } from './zoom';

  let { map = null }: { map?: MlMap | null } = $props();
  let zoom = $state(0);

  $effect(() => {
    const m = map;
    if (!m) return;
    const update = () => {
      zoom = m.getZoom();
    };
    update();
    m.on('zoom', update);
    return () => m.off('zoom', update);
  });
</script>

<span class="zoom-level" aria-label={`zoom level ${Math.round(zoom)}`}>&thinsp;·&thinsp;{formatZoom(zoom)}</span>

<style>
  .zoom-level {
    color: var(--sub);
    cursor: default;
    font: var(--fs-micro) / 1.6 var(--mono);
  }
</style>
